import { useLoginInfo } from 'hooks/useLoginInfo';
import { useState } from 'react';
import { roleutil } from 'util/roleutil';
import { BottomSpace } from './BottomSpace';
import { Divider } from './Divider';
import { MenuItem } from './MenuItem';
import { SubMenuProdGuide } from './submenu/SubMenuProdGuide';
import useMenuUrl, { MenuItemWrap } from './useMenuUrl';

export const MainMenuKr = ({ onClose, onClickAiChatbot }: { onClose: () => void; onClickAiChatbot: () => void }) => {
  const { getMenuUrl } = useMenuUrl({ type: 'menu' });

  const [showMenuProdGuide, setShowMenuProdGuide] = useState(false);

  const handleClickAiChatbot = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    // const menu = getMenuUrl('ai-chatbot');
    // openChatBot(menu.href || menu.to);
    // onClose();
    onClickAiChatbot();
  };
  const loginInfo = useLoginInfo();

  /*
  const { isPartner } = useZstdHeader();
    const loginInfo = useLoginInfo();
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  const svcLang = svcs.svcLang.lang(); // 서비스 언어.
        {((loginutil.iswels(loginInfo) && [LANG_EN].includes(svcLang)) || (svcLang == LANG_EN && isPartner)) && (
        <CategorySubList
          link={`/${country}/${lang}/community/partner`}
          imageUrl="partner.svg"
          title="I18N_TITLE_COMMUNITY_LS_PARTNER"
          intro="I18N_TITLE_COMMUNITY_LS_PARTNER_INTRO"
        />
      )}
      {svcLang == LANG_KO_KR && roleutil.hasRole('RND', loginInfo.userRoles) && (
        <CategorySubList
          link={`/${country}/${lang}/community/rnd`}
          imageUrl="rnd.svg"
          title="I18N_TITLE_COMMUNITY_RND"
          intro="I18N_TITLE_COMMUNITY_RND_INTRO"
        />
      )}
  */
  return (
    <>
      <MenuItemWrap menuId="ai-chatbot" onClick={handleClickAiChatbot} type="menu" />

      <Divider />
      <MenuItemWrap menuId="dlcenter" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="knowledge" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="sample" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="qna" onClick={onClose} type="menu" />

      <Divider />
      <MenuItemWrap menuId="asset-insight" onClick={onClose} type="menu" />

      <MenuItemWrap menuId="energy-simul" onClick={onClose} type="menu" />

      <MenuItemWrap menuId="remote" onClick={onClose} type="menu" />
      <MenuItem
        label={getMenuUrl('prod-selector').label}
        onClick={() => setShowMenuProdGuide(!showMenuProdGuide)}
        isSubMenu
        showSubMenu={showMenuProdGuide}
      />
      {showMenuProdGuide && <SubMenuProdGuide onClose={onClose} />}

      <Divider />
      {roleutil.hasRole('RND', loginInfo?.userRoles) && <MenuItemWrap menuId="rnd" onClick={onClose} type="menu" />}
      <MenuItemWrap menuId="tech-square" onClick={onClose} type="menu" />
      <MenuItemWrap menuId="ls-electric" onClick={onClose} type="menu" />

      <Divider />
      <MenuItemWrap menuId="news-event" onClick={onClose} type="menu" />
      <BottomSpace />
      <div style={{ flex: 1 }}></div>
    </>
  );
};
